module.exports = __webpack_public_path__ + "static/pierreplume-a75e32df6bceceeb7f40162e13f30ae3.jpg";